
import Vue from 'vue'
import ModalSimple from '@/components/ModalSimple.vue'
export default Vue.extend({
  components: {
    ModalSimple
  },
  props: {
    downloadLink: {
      type: String,
      required: true
    }
  },
  data():{
    acceptedTermOfUse: boolean
  } {
    return {
      acceptedTermOfUse: false
    }
  },
  methods: {
    closeModal() {
      this.$emit('close-modal')
    }
  }
})
